import store from '@/store/index'

export default {
  // Do not allow guest users to access auth routes
  //
  isLoggedIn: (to, from, next) => {
    if (store.getters.isUserLoggedIn) {
      next()
    } else {
      next(`?authModal=true&prev=${to.fullPath}`)
    }
  },

  isUserLoggedIn: (to, from, next) => {
    // let redirection ='';
    if (store.getters.isUserLoggedIn) {
      next()
    } else {
      // window.location = '/expertsourcing/'
      window.location.href = `${process.env.VUE_APP_SERVER_BASE_URL}`;
    }
  },

  // Do not allow logged-in users to access guest routes
  //
  isGuest: (to, from, next) => {
    if (store.getters.isUserLoggedIn) {
      // next({ name: 'Home' })
      window.location.href = `${process.env.VUE_APP_SERVER_BASE_URL}`;
    } else {
      next()
    }
  }
}